// extracted by mini-css-extract-plugin
export var dropdownIcon = "_i1-6";
export var imgContainer = "_i1-3";
export var menuIcon = "_i1-5";
export var pillWrapper = "_i1-2";
export var pillsContainer = "_i1-1";
export var subscriptionCard = "_i1-0";
export var subscriptionLogo = "_i1-4";